import { useEffect, useState } from "react";
import { ApisService } from "../../../app/core/apis.service";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { useParams } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
import { Breadcrumb } from "../../breadcum";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";

export const UserView = () => {
    const params = useParams();
    const [userData, setUserData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        loadUsers({ id: params.id });
    }, []);
    async function loadUsers(data: any): Promise<void> {
        setLoading(true);
        try {
            let encrytedData = encrypt(JSON.stringify(data));
            const res = await ApisService.usersApi("getById", encrytedData);
            const encryptData = JSON.parse(dataDecrypt(res.data.data));
            getUserRoleData(encryptData[0]);
        }
        catch (error) {
            setLoading(false); 
        }
    }

    const getUserRoleData = async (data: any) => {
        let payload = { id: params.org };
        try {
            let encrytedData = encrypt(JSON.stringify(payload));
            const res = await ApisService.getOrganizationData("findById", encrytedData);
            const userData = JSON.parse(dataDecrypt(res.data.data));
            const filterData = userData[0].roles.filter((item: any) => item.role_id === data.business_units[0].roles[0]);
            setUserData({ ...data, permissions: filterData })
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    
    const breadcrumbInfo = [
        {
            label: "Users",
            value: "Users",
            routerLink: `/dashboard/organizations/org-details/${params.page}/${params.org}/users`,
            isActive: false,
        },
        {
            label: `Info`,
            value: `Info`,
            routerLink: ``,
            isActive: true,
        },
    ];

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            <h4 className="primary-color fw-bold ">User Info</h4>
            {loading && (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                    </div> 
                </div>
            )}
            {!loading && (<div>
                <div className="card mb-2">
                    <div className="card-body">
                        <h6 className="fw-bold">Personal Information</h6>
                        <div className="row">
                            <div className="col-3 lh-1-5">
                                <b className="mb-0">Name</b>
                                <div>{userData?.name}</div>
                            </div>
                            <div className="col-3 lh-1-5">
                                <b className="mb-0">Mobile Number</b>
                                <div>{userData?.contact}</div>
                            </div>
                            <div className="col-3 lh-1-5">
                                <b className="mb-0">Register Date</b>
                                <div>{FormatIndianDate(userData?.created_date,"")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h6 className="mb-0 fw-bold">Roles & Privileges</h6>
                        <Accordion className="mt-2 ">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>{userData?.permissions[0]?.name}</Accordion.Header>
                                <Accordion.Body>
                                    {userData?.permissions[0]?.permissions.map((value: any, index: any) => (<div className="" key={index}><TiTick className="text-success me-1" size={20} />{value.replace(/_/g, " ")}</div>))}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>)}
        </div>
    )
}